<div class="modal-header">
    <h4 class="modal-title">Godkendte planer</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Kundenr</th>
            <th scope="col">Firma</th>
            <th scope="col">Navn</th>
            <th scope="col">Godkendt</th>
            <th scope="col">Init</th>
            <th scope="col">Set</th>
        </thead>
        <tbody>
            <tr *ngFor="let client of planerGodkendt"
            class="clickable"
            (click)="onGotoKundeEval(client)">
                <td>{{client?.glkundenr}}</td>
                <td>{{client.navn1}}</td>
                <td>{{client.navn2}}</td>
                <td>{{client.planGodkendt | date:'dd-MM-yyyy'}}</td>
                <td>{{client.planGodkendtAf}}</td>
                <td><button class="btn btn-sm btn-primary" (click)="onUpdateSeen($event, client.kid)">Set</button></td>
            </tr>
        </tbody>
    </table>
</div>
